import React from 'react';
import { PARQ_QUESTIONS } from '../../../../constants/parqQuestions';
import { getPublicParqFieldElementId } from '../../../ParQ/ParQRegister/publicParq.utils';
import SectionTitle from '../../../../components/common/SectionTitle/SectionTitle';
import { ParQFormData } from '../../../../types/registration';
import BaseFormTextarea from '../../../../components/common/FormTextarea/FormTextarea';
import { AppFormTextarea } from '../../../../components/common/appForms';
import {
  AppSectionTitle,
  appOnboardingText,
} from '../../../../components/common/appUi';
import BooleanRadio from '../../../../components/common/BooleanRadio/BooleanRadio';
import publicStyles from '../../../ParQ/ParQRegister/ParQRegister.module.css';
import styles from '../StudentRegister.module.css';

interface ParQStepProps {
  data: ParQFormData;
  errors: Record<string, string>;
  onFieldChange: <K extends keyof ParQFormData>(field: K, value: ParQFormData[K]) => void;
  readOnly?: boolean;
  disabled?: boolean;
  useAppInputs?: boolean;
  titleAction?: React.ReactNode;
}

const ParQStep: React.FC<ParQStepProps> = ({
  data,
  errors,
  onFieldChange,
  readOnly = false,
  disabled = false,
  useAppInputs = false,
  titleAction,
}) => {
  const FormTextarea = useAppInputs ? AppFormTextarea : BaseFormTextarea;
  const isLocked = readOnly || disabled;

  if (useAppInputs) {
    return (
      <div>
        <AppSectionTitle className={publicStyles.sectionTitle}>
          Questionário
        </AppSectionTitle>

        {PARQ_QUESTIONS.map((question, index) => (
          <div
            key={question.field}
            id={getPublicParqFieldElementId(question.field)}
            className={publicStyles.questionBlock}
          >
            <p className={appOnboardingText.question}>
              {`${index + 1}. ${question.label}`}
              <span className={appOnboardingText.required}> *</span>
            </p>
            <BooleanRadio
              name={question.field}
              value={data[question.field]}
              onChange={(value) => onFieldChange(question.field, value)}
              disabled={isLocked}
              error={errors[question.field]}
            />

            {question.detailFormField && data[question.field] === true && (
              <AppFormTextarea
                id={getPublicParqFieldElementId(question.detailFormField)}
                label={question.detailLabel}
                value={data[question.detailFormField]}
                onChange={(event) => onFieldChange(question.detailFormField!, event.target.value)}
                placeholder={question.detailPlaceholder}
                error={errors[question.detailFormField]}
                required
                readOnly={readOnly}
                disabled={disabled}
              />
            )}
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={styles.card}>
      <div>
        <div className={styles.sectionHeaderRow}>
          <SectionTitle as="h2" text="Questionário PAR-Q" />
          {titleAction}
        </div>
        <p className={styles.sectionDescription}>
          Questionário de prontidão para atividade física. Responda todas as perguntas.
        </p>

        <div className={styles.formGridFull}>
          {PARQ_QUESTIONS.map((question) => (
            <div
              key={question.field}
              id={getPublicParqFieldElementId(question.field)}
              className={styles.fieldGroup}
              style={{ marginBottom: 'var(--spacing-sm)' }}
            >
              <label className={styles.label}>
                {question.label}
              </label>
              <BooleanRadio
                name={question.field}
                value={data[question.field] as boolean | null}
                onChange={(value) => onFieldChange(question.field, value as ParQFormData[typeof question.field])}
                disabled={isLocked}
                error={errors[question.field]}
              />

              {question.detailFormField && data[question.field] === true && (
                <FormTextarea
                  id={getPublicParqFieldElementId(question.detailFormField)}
                  label={question.detailLabel}
                  value={data[question.detailFormField]}
                  onChange={(event) => onFieldChange(question.detailFormField!, event.target.value)}
                  error={errors[question.detailFormField]}
                  required
                  readOnly={readOnly}
                  disabled={disabled}
                />
              )}
            </div>
          ))}

          {/* Declaração de responsabilidade temporariamente desabilitada
          <div
            className={styles.fieldGroup}
            style={{
              marginTop: 'var(--spacing-md)',
              paddingTop: 'var(--spacing-md)',
              borderTop: '1px solid var(--color-brand-beige)',
            }}
          >
            <label className={styles.label}>Declaração de responsabilidade</label>
            <div className={styles.radioGroup}>
              <label className={styles.radioLabel}>
                <input
                  type="radio"
                  name="responsibility"
                  checked={data.responsibility === 'ciente'}
                  onChange={() => onFieldChange('responsibility', 'ciente')}
                  disabled={readOnly}
                />
                Estou ciente da minha responsabilidade
              </label>
            </div>
            {errors.responsibility && <span className={styles.errorText}>{errors.responsibility}</span>}
          </div>
          */}
        </div>
      </div>
    </div>
  );
};

export default ParQStep;
